import { CSSProperties, ReactElement } from 'react';
import { tokens } from '../../theme';

/** Classe utilitária definida em src/index.css — :focus não é alcançável via style inline. */
const SKIP_LINK_CLASS_NAME = 'skip-link';

export const MAIN_CONTENT_ID = 'main-content';

/** Fica oculto fora da tela até receber foco de teclado (Tab), quando se torna visível sobre o header. */
export const SkipLink = (): ReactElement => {
  return (
    <a href={`#${MAIN_CONTENT_ID}`} className={SKIP_LINK_CLASS_NAME} style={styleVars}>
      Pular para o conteúdo principal
    </a>
  );
};

const styleVars = {
  '--skip-link-background': tokens.colors.global.white,
  '--skip-link-color': tokens.colors.brand.red.DEFAULT,
  '--skip-link-padding': `${tokens.spacing.small} ${tokens.spacing.default}`,
  '--skip-link-font-size': tokens.typography.fontSize.button,
  '--skip-link-font-weight': String(tokens.typography.fontWeight.medium),
} as CSSProperties;
